module.exports = __webpack_public_path__ + "static/media/dislike.07fa6b9f.svg";